module.exports = __webpack_public_path__ + "h5/img/share-info.fa0bedf8.png";